import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const GladstoneParkCdbsDentistPage = () => (
  <ServiceLocationTemplate suburbName="Gladstone Park" suburbSlug="gladstone-park" variant="cdbs-dentist" />
);

export default GladstoneParkCdbsDentistPage;
